import { registerLocaleData } from '@angular/common';
import localePt from '@angular/common/locales/pt';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { BrowserModule } from '@angular/platform-browser';
import { BodyModule } from 'app/body/body.module';
import { ComponentesModule } from 'app/resources/componentes/componentes.module';
import { DiretivesModule } from 'app/resources/diretives/diretives.module';
import { AuthGuard, AvisoService, CartaoService, CepService, CiService, CssService, DownloadService, HttpService, LoginService, LojaCarrinhoService, LojaService, MainService, PagamentoService, ParceiroService, PermissionService, SacService, SaldoService, ServicesService, SessionService, ValePresenteCestaService, ValePresenteService } from 'app/resources/services/index';
import { RecaptchaModule } from 'ng-recaptcha';
import { RecaptchaFormsModule } from 'ng-recaptcha/forms';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CadastroUsuarioComponent } from './cadastro-usuario/cadastro-usuario.component';
import { ChaveDeAcessoComponent } from './public/chave-de-acesso/chave-de-acesso.component';
import { LoginComponent } from './public/login/login.component';
import { MakepwdComponent } from './public/makepwd/makepwd.component';
import { CartaoDestinoPipe } from './resources/pipes/index';
import { VoucherService } from './resources/services/voucher.service';
import { AlertService } from './resources/services/alert.service';
import { PoliticaTermoService } from './resources/services/politica-termo.service';
import { InstitucionalComponent } from './public/institucional/institucional.component';
import { HeaderComponent } from './public/header/header.component';
import { FooterComponent } from './public/footer/footer.component';
import { SendMailService } from './resources/services/send-mail.service';

registerLocaleData(localePt, 'pt');

@NgModule({
    declarations: [
        AppComponent,
        LoginComponent,
        CartaoDestinoPipe,
        MakepwdComponent,
        CadastroUsuarioComponent,
        ChaveDeAcessoComponent,
        InstitucionalComponent,
        HeaderComponent,
        FooterComponent
    ],
    imports: [
        BrowserModule,
        FormsModule,
        HttpModule,
        AppRoutingModule,
        BodyModule,
        ComponentesModule,
        DiretivesModule,
        RecaptchaModule,
        RecaptchaFormsModule
    ],
    providers: [
        LoginService,
        SessionService,
        CiService,
        HttpService,
        PermissionService,
        CartaoService,
        CssService,
        SaldoService,
        DownloadService,
        ServicesService,
        MainService,
        AuthGuard,
        PagamentoService,
        CepService,
        ValePresenteCestaService,
        ValePresenteService,
        ParceiroService,
        LojaService,
        LojaCarrinhoService,
        SacService,
        AvisoService,
        VoucherService,
        AlertService,
        PoliticaTermoService,
        SendMailService
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts